module.exports = __webpack_public_path__ + "media/images/emblems/Prangins-coat_of_arms-c09c2a7a7302e45a6bb428dcd3ab29e8.svg";